import { render, staticRenderFns } from "./ValuePicker.vue?vue&type=template&id=228402af"
import script from "./ValuePicker.vue?vue&type=script&lang=js"
export * from "./ValuePicker.vue?vue&type=script&lang=js"
import style0 from "./ValuePicker.vue?vue&type=style&index=0&id=228402af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports